import ImportDataBody from 'components/Settings/ImportData';

export const ImportData = () => <ImportDataBody />;
